import { useRef } from "react";
import { useParams } from "react-router-dom";
import { FormikProps } from "formik";
import { useConfirm } from "material-ui-confirm";
import * as L from "leaflet";
import { useTranslation } from "react-i18next";

import { EmissionType } from "src/types";
import {
  useEmission,
  useSubstances,
  usePointSource,
  usePointSourceUpdateMutation,
  usePointSourceDeleteMutation,
} from "src/hooks";
import { useScenario } from "src/hooks/useScenario";
import { PointSourceOnMap } from "src/components/on-map/PointSourceOnMap";
import { PointSourceForm, PointSourceFormData } from "src/forms/PointSourceForm";
import { isReadOnly } from "src/utils/permission.utils";
import { useTimefactors } from "src/hooks/timefactorHooks";

interface Props {
  map: L.Map;
  onClose: (originAction?: "delete") => void;
}

export function PointSourceEmissionPointSourceEditPage(props: Props) {
  const { t } = useTranslation();
  const {
    scenarioId = "",
    emissionId = "",
    pointSourceId = "",
  } = useParams<{
    caseId: string;
    scenarioId: string;
    emissionId: string;
    pointSourceId: string;
  }>();
  const { data: scenario } = useScenario(scenarioId);
  const { data: substances } = useSubstances();
  const { data: pointSource } = usePointSource(scenarioId, emissionId, pointSourceId);
  const { data: emission } = useEmission(scenarioId, emissionId, EmissionType.POINT_SOURCE);
  const { data: timefactors } = useTimefactors();
  const confirm = useConfirm();

  const formRef = useRef<FormikProps<PointSourceFormData> | null>(null);

  const updateMutation = usePointSourceUpdateMutation(scenarioId, emissionId, pointSourceId);
  const deleteMutation = usePointSourceDeleteMutation(scenarioId, emissionId, pointSourceId);

  /**
   * Effects
   */

  /**
   * Functions
   */
  // function isDirty() {
  //   return formRef.current?.dirty === true;
  // }

  function handleDiscardChanges() {
    // setDirtyData({});
  }

  function handleSave(values: PointSourceFormData) {
    if (!pointSource) return Promise.reject();
    return updateMutation
      .mutateAsync({
        ...pointSource,
        ...values,
      })
      .then(() => props.onClose());
  }

  async function handleDelete() {
    if (!pointSource) return;

    confirm({
      confirmationButtonProps: { autoFocus: true },
      title: t("label.areYouSure"),
      description: t("confirm.deletePointSource"),
    })
      .then(deleteMutation.mutateAsync)
      .then(() => props.onClose("delete"));
  }

  return render();

  function render() {
    if (!scenario || !emission || !pointSource || !substances || !timefactors) return null;

    return (
      <>
        <PointSourceForm
          timefactors={timefactors || []}
          key={pointSourceId}
          title={t("label.pointSourceDetails")}
          data={pointSource}
          substances={substances}
          readOnly={isReadOnly(scenario.permissions.updateEmission)}
          isLoading={updateMutation.isLoading}
          onSubmit={handleSave}
          onClose={() => {
            handleDiscardChanges();
            props.onClose();
          }}
          onDelete={handleDelete}
          errors={updateMutation.error?.response?.data}
          formRef={formRef}
        />

        <PointSourceOnMap
          map={props.map}
          scenarioId={scenarioId}
          emissionId={emissionId}
          pointSourceId={pointSourceId}
        />

        {renderNavigationConfirm()}
      </>
    );
  }

  function renderNavigationConfirm() {
    return null;
    // <NavigationConfirm when={isDirty}>
    //   {({ onConfirm, onCancel }) => (
    //     <ConfirmUnsavedDialog
    //       open
    //       onDiscard={() => {
    //         handleDiscardChanges();
    //         onConfirm();
    //       }}
    //       onSave={() => {
    //         // submit form and go back to the form
    //         formRef.current?.submitForm();
    //         onCancel();
    //       }}
    //       onCancel={() => {
    //         onCancel();
    //       }}
    //     />
    //   )}
    // </NavigationConfirm>
  }
}
